import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import {
  IProtectAndSave,
  IProtectAndSaveTab,
  IStrapiDocument,
  ProtectAndSaveProductPreview
} from 'src/app/interfaces/strapi';
import { UserService } from 'src/app/services/user.service';
import { PageComponent } from 'src/app/shared/components/page/page.component';
import StrapiService from 'src/app/services/strapi.service';
import { NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';
import { GenericTabsComponent, TabData } from '../generic-tabs/generic-tabs.component';
import { BreadcrumbsComponent } from '../../../shared/components/breadcrumbs/breadcrumbs.component';
import {
  PageRetrievalErrorComponent
} from '../../../shared/components/page-retrieval-error/page-retrieval-error.component';
import { BannerComponent } from '../../../shared/components/banner/banner.component';

@Component({
    selector: 'app-protect-and-save',
    templateUrl: './protect-and-save.component.html',
    styleUrls: ['./protect-and-save.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,
    imports: [
        BreadcrumbsComponent,
        NgIf,
        PageRetrievalErrorComponent,
        BannerComponent,
        GenericTabsComponent,
        NgFor,
        RouterLink,
    ],
})
export class ProtectAndSaveComponent extends PageComponent implements OnInit {
  public override pageData: IProtectAndSave = <IProtectAndSave>{};

  public isLoading: boolean = false;

  public tabData: TabData[] = [];

  public currentProductData: ProtectAndSaveProductPreview[] = [];

  constructor(
    protected override readonly titleService: Title,
    protected override readonly metaService: Meta,
    public override readonly strapi: StrapiService,
    public readonly userService: UserService,
    private readonly cdr: ChangeDetectorRef
  ) {
    super(titleService, metaService, strapi);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.strapi
      .getProtectAndSave()
      .subscribe((data: IStrapiDocument<IProtectAndSave>) => {
        this.parsePageData(data);
        super.setMetas();
        this.cdr.markForCheck();
      });
  }

  protected override parsePageData(
    page: IStrapiDocument<IProtectAndSave>
  ): void {
    this.pageData = page.data.attributes;
    this.isLoading = false;
    this.initTabData();
    super.parsePageData(this.pageData);
  }

  /**
   * Initializes tab data on page load
   *
   * @return void
   */
  private initTabData(): void {
    this.tabData = this.pageData.tab.map(
      (tab: IProtectAndSaveTab, index: number) =>
        ({
          title: tab.tab_name,
          id: tab.tab_uid,
          isActive: index === 0,
        } as TabData)
    );
    this.setCurrentProduct();
  }

  /**
   * Sets the currentProtectData to whatever the active tab is
   *
   * @return void
   */
  private setCurrentProduct(): void {
    const activeTabUid = this.tabData.find((tab) => tab.isActive)?.id;
    if (activeTabUid) {
      const products = this.pageData.tab.find(
        (tab: IProtectAndSaveTab) => tab.tab_uid === activeTabUid
      )?.product;
      if (products) this.currentProductData = products;
    }
  }

  /**
   * change the active tab to the user selected one
   *
   * @param tabid
   * @return void
   */
  private changeActiveTab(tabid: string): void {
    this.tabData.map((tab: TabData) => ({
      ...tab,
      isActive: tab.id === tabid,
    }));
  }

  /**
   * Runs when users selected a new tab from the generic tab component
   * @param tabId
   */
  public onTabChanged(tabId: string): void {
    this.changeActiveTab(tabId);
    this.setCurrentProduct();
  }
}
